import {Link} from 'react-router-dom';

const Home = () => (
  <div className="p-4 flex flex-col justify-center items-center w-full h-screen">
    <h1>Weshare Webapp Homepage!</h1>

    <Link to="/products" className="underline italic text-blue-600">
      Click here to go to products dashboard
    </Link>
  </div>
);

export default Home;
